import React, { useState, useEffect } from 'react';
import { api } from '../../api';

const parseDate = (d) => { if (!d) return null; if (d?.seconds) return new Date(d.seconds * 1000); return new Date(d); };

const VehiculosSection = () => {
  const [vehiculos,      setVehiculos]      = useState([]);
  const [loading,        setLoading]        = useState(true);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [searchTerm,     setSearchTerm]     = useState('');

  useEffect(() => { loadVehiculos(); }, []);

  const loadVehiculos = async () => {
    try {
      setLoading(true);
      const data = await api.get('/vehiculos');
      setVehiculos(Array.isArray(data) ? data : data.vehiculos || []);
    } catch (error) {
      console.error('Error cargando vehículos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!editingVehicle) return;
    try {
      const { id, _id, ...updateData } = editingVehicle;
      await api.put(`/vehiculos/admin/${id || _id}`, updateData);
      setVehiculos(prev => prev.map(v => (v.id || v._id) === (id || _id) ? editingVehicle : v));
      setEditingVehicle(null);
      alert('Vehículo actualizado correctamente');
    } catch (error) {
      alert('Error al actualizar vehículo: ' + error.message);
    }
  };

  const togglePlacaSystem = async (vehicleId, currentRequiresPlaca) => {
    try {
      const newRequiresPlaca = !currentRequiresPlaca;
      const updates = {
        requiresPlaca: newRequiresPlaca,
        usable: newRequiresPlaca,
        ...(!newRequiresPlaca ? { placaMAC: null } : {})
      };
      await api.put(`/vehiculos/admin/${vehicleId}`, updates);
      setVehiculos(prev => prev.map(v => (v.id || v._id) === vehicleId ? { ...v, ...updates } : v));
      alert(`Sistema de placa ${newRequiresPlaca ? 'activado' : 'desactivado'} correctamente`);
    } catch (error) {
      alert('Error al cambiar sistema de placa: ' + error.message);
    }
  };

  const filteredVehiculos = vehiculos.filter(v =>
    v.aditamento?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    v.patente?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    v.categories?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return (
    <div className="section-loading"><div className="spinner"></div><p>Cargando vehículos...</p></div>
  );

  return (
    <div className="section-container">
      <div className="section-header">
        <h1>Gestión de Vehículos</h1>
        <p>Administre taxis, patentes, categorías y estado del Bluetooth</p>
      </div>

      <div className="search-container">
        <input type="text" placeholder="Buscar por aditamento, patente o categoría..."
          value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="search-input" />
        <span className="search-results">{filteredVehiculos.length} vehículo(s) encontrado(s)</span>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr><th>Aditamento</th><th>Patente</th><th>Categoría</th><th>Placa</th><th>Pagado</th><th>Vencimiento</th><th>Acciones</th></tr>
          </thead>
          <tbody>
            {filteredVehiculos.map(vehiculo => {
              const vid = vehiculo.id || vehiculo._id;
              const vencimiento = parseDate(vehiculo.fechaVencimiento);
              return (
                <tr key={vid}>
                  <td><span className="aditamento-badge">{vehiculo.aditamento || 'N/A'}</span></td>
                  <td><strong>{vehiculo.patente || 'N/A'}</strong></td>
                  <td><span className="category-badge">{vehiculo.categories || 'N/A'}</span></td>
                  <td>
                    <div className="placa-system">
                      {vehiculo.requiresPlaca ? (
                        <div>
                          <button className="bluetooth-toggle active"
                            onClick={() => togglePlacaSystem(vid, vehiculo.requiresPlaca)}
                            title="Click para desactivar sistema de placa">🔒 CON PLACA</button>
                          {vehiculo.placaMAC && <small style={{ display: 'block', fontSize: '10px', color: '#666', marginTop: '4px' }}>{vehiculo.placaMAC}</small>}
                        </div>
                      ) : (
                        <button className="bluetooth-toggle inactive"
                          onClick={() => togglePlacaSystem(vid, vehiculo.requiresPlaca)}
                          title="Click para activar sistema de placa">📱 SIN PLACA</button>
                      )}
                    </div>
                  </td>
                  <td><span className={`payment-badge ${vehiculo.isPaid ? 'paid' : 'unpaid'}`}>{vehiculo.isPaid ? '✅ Sí' : '❌ No'}</span></td>
                  <td>{vencimiento ? vencimiento.toLocaleDateString() : 'N/A'}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn btn-sm btn-primary" onClick={() => setEditingVehicle({ ...vehiculo, id: vid })}>Editar</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filteredVehiculos.length === 0 && <div className="no-data"><p>No se encontraron vehículos</p></div>}
      </div>

      {editingVehicle && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>Editar Vehículo</h3>
              <button className="modal-close" onClick={() => setEditingVehicle(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Aditamento</label>
                  <input type="text" value={editingVehicle.aditamento || ''} className="form-control"
                    readOnly style={{ backgroundColor: '#f5f5f5' }} />
                  <small>El aditamento no se puede modificar</small>
                </div>
                <div className="form-group">
                  <label>Patente</label>
                  <input type="text" value={editingVehicle.patente || ''} className="form-control"
                    placeholder="ABC123"
                    onChange={e => setEditingVehicle(p => ({ ...p, patente: e.target.value.toUpperCase() }))} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Categoría</label>
                  <select value={editingVehicle.categories || ''} className="form-control"
                    onChange={e => setEditingVehicle(p => ({ ...p, categories: e.target.value }))}>
                    <option value="">Seleccionar categoría</option>
                    <option value="taxi">Taxi</option>
                    <option value="remis">Remis</option>
                    <option value="especial">Especial</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Sistema de Placa ESP32</label>
                  <select value={editingVehicle.requiresPlaca ? 'true' : 'false'} className="form-control"
                    onChange={e => setEditingVehicle(p => ({ ...p, requiresPlaca: e.target.value === 'true', usable: e.target.value === 'true' }))}>
                    <option value="false">📱 Sin Placa (Funcionamiento Normal)</option>
                    <option value="true">🔒 Con Placa ESP32 (Vinculación Requerida)</option>
                  </select>
                </div>
                {editingVehicle.requiresPlaca && (
                  <div className="form-group">
                    <label>MAC de la Placa ESP32</label>
                    <input type="text" value={editingVehicle.placaMAC || ''} className="form-control"
                      placeholder="AA:BB:CC:DD:EE:FF"
                      onChange={e => setEditingVehicle(p => ({ ...p, placaMAC: e.target.value.toUpperCase() }))} />
                    <small>Formato: AA:BB:CC:DD:EE:FF</small>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setEditingVehicle(null)}>Cancelar</button>
              <button className="btn btn-primary"   onClick={handleSave}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehiculosSection;
